import { render, staticRenderFns } from "./AdminCargaMasivaComponent.vue?vue&type=template&id=10fed56f&"
import script from "./AdminCargaMasivaComponent.vue?vue&type=script&lang=js&"
export * from "./AdminCargaMasivaComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports